import { cn } from '@/lib/utils';

const variantClasses: Record<string, string> = {
  default: 'bg-muted text-foreground',
  success: 'bg-emerald-100 text-emerald-800',
  warning: 'bg-amber-100 text-amber-800',
  danger: 'bg-rose-100 text-rose-800',
  info: 'bg-sky-100 text-sky-800',
  primary: 'bg-indigo-100 text-indigo-800',
};

interface BadgeProps {
  variant?: keyof typeof variantClasses;
  children: React.ReactNode;
  className?: string;
}

export function Badge({ variant = 'default', children, className }: BadgeProps) {
  return (
    <span className={cn('inline-flex items-center text-xs px-2 py-0.5 rounded font-medium', variantClasses[variant], className)}>
      {children}
    </span>
  );
}
